export const formatInputValue = (value) => {
  if (value === null || value === undefined || value === 0 || value === 0.0) return "";
  return String(value);
};

export const parseInputValue = (value) => {
  if (value === "" || value === null || value === undefined) return 0;
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
};

export const formatCount = (value) => new Intl.NumberFormat("fr-FR").format(value ?? 0);
